<template>
  <SelectSingleInput
    v-model="model"
    :items="items"
    item-text="partText"
    item-value="ptCd"
    :label="label"
    :disabled="disabled"
    :loading="loading"
    :required="required"
    :isSelectedAuto="false"
    @change="onChange"
  />
</template>

<script>
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'

export default {
  name: 'PtCdInput',

  mixins: [APIUtils, Message],
  components: { SelectSingleInput },

  props: {
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: function () {
        return this.$t('ELE0059')
      },
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    partGroupCd: {
      type: String,
      required: true,
    },
    supplierCd: {
      type: String,
      required: true,
    },
    validOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      items: [],
      loading: false,
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
  },

  watch: {
    async partGroupCd(value) {
      await this.setParts(this.supplierCd, value)
    },
    async supplierCd(value) {
      await this.setParts(value, this.partGroupCd)
    },
  },

  methods: {
    onChange(value) {
      this.$emit('change', value)
    },

    async setParts(supplierCd, partGroupCd) {
      this.loading = true
      this.items = []

      try {
        if (supplierCd) {
          let params = { supplierCd: supplierCd, partGroupCd: partGroupCd }
          if (this.validOnly) {
            params.validOnly = true
          }

          const elements = await API.get('/master/pts', params)
          let parts = []
          elements.forEach((element) => {
            parts.push({
              ptCd: element['ptCd'],
              partName: element['partName'],
              partText: `${element['ptCd']} : ${element['partName']}`,
            })
          })

          // pt_cdの重複排除(findIndexで1回目に見つかったptCdのみを抽出)
          this.items = parts.filter((element, index, self) => self.findIndex((e) => e.ptCd === element.ptCd) === index)
        }
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0059') })))
      } finally {
        this.loading = false
      }
    },
  },

  async mounted() {
    await this.setParts(this.supplierCd, this.partGroupCd)
  },
}
</script>
